import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Badge from 'react-bootstrap/Badge';

import Link from '../../Link/Link';
import Loader from '../../Common/Loader/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';

import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';
import { removeExperience, uploadExperience } from '../../../actions/siteadmin/Document/uploadExperience';
import { uploadProfileImage } from '../../../actions/siteadmin/uploadProfileImage';
import { uploadIdentity } from '../../../actions/siteadmin/Document/uploadIdentity';
import { api, profilePhotouploadDir, documentUploadDir } from '../../../config';

import defaultIcon from '../../../../public/Icons/defaultImage.svg';
import deleteIcon from '../../../../public/Icons/delete.svg';

import s from './EditPartnerForm.css'
import bt from '../../../components/commonStyle.css';

export class EditPartnerForm extends Component {
	constructor(props) {
		super(props)
		this.state = {
			countryCode: 'IN',
			country: '+91'
		}
	}

	static defaultProps = {
		loading: false
	};

	componentDidMount() {
		const { initialValues } = this.props;

		if (initialValues && initialValues?.country && initialValues?.phoneCountryCode) {
			this.setState({
				countryCode: initialValues?.phoneCountryCode,
				country: initialValues?.country
			});
		}
	}

	successProfile = async (fileName) => {
		const { change, uploadProfileImage, id, picture } = this.props;
		await change('picture', fileName);
		await uploadProfileImage(id, fileName, picture);
	}

	successIdentity = async (fileName) => {
		const { uploadIdentity, id } = this.props;
		await uploadIdentity(id, fileName);
	}

	successExperience = async (fileName) => {
		const { uploadExperience, id } = this.props;
		await uploadExperience(id, fileName);
	}

	renderField = ({ input, label, type, meta: { touched, error }, fieldClass, placeholder, disabled }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group>
				<label className={bt.labelText} >{label}</label>
				<Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} disabled={disabled} />
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}
	renderFieldPhoneNumber = ({ input, label, writeOnce, type, meta: { touched, error }, fieldClass, placeholder, disabled }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group>
				<Form.Control {...input} readOnly={writeOnce} placeholder={placeholder} type={type} className={bt.formControlInput} disabled={disabled} />
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}
	handleChange = (event) => {
		this.setState({ [event.target.name]: event.target.value });
	}

	handleCountryChange = (e, selectedData) => {
		this.setState({
			country: selectedData.dialCode,
			countryCode: selectedData.countryCode
		});
	}

	render() {
		const { handleSubmit, id, picture, loading, submitting, getUser, identityDocument, experienceDocument, removeExperience, userIdentityLoading, userProfileLoading, userExperienceLoading } = this.props;
		const { currency } = this.props;
		const { formatMessage } = this.props.intl;
		
		return (
			<div className={cx('cardSection', s.widthInner, bt.space5, 'tabLabelText')}>
				<Row>
					<Col md={12} lg={12} sm={12} xs={12}>
						<Card className={s.card}>
							<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
								<h1 className={cx('textAlignRightRTL', s.headingTwo, 'textWhite')}>
									{formatMessage(messages.editPartner)}
									<span className={s.userStatusBadge}>
										<Badge pill variant={getUser && getUser.result && getUser.result.isActive === 1 && getUser.result.isBan === 0 ? 'success' : 'danger'}>
											{getUser && getUser.result && getUser.result.isActive === 1 && getUser.result.isBan === 0 ? formatMessage(messages.online) : formatMessage(messages.offline)}
										</Badge>
										{' '}
										{getUser && getUser.result && getUser.result.isActive === 1 && getUser.result.isBan === 0 && <Badge pill variant={getUser.result.activeStatus === "inactive" ? 'success' : 'danger'}>
											{getUser.result.activeStatus === "inactive" ? formatMessage(messages.eligibleForAService) : formatMessage(messages.notEligibleForAService)}
										</Badge>}
									</span>
								</h1>
								<Row>
									<Col lg={12} md={12} sm={12} xs={12} className={cx(bt.space2, s.marbtm14)}>
										<Form.Group className={cx(s.formGroup, s.singalCard)}>
											<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
												<div className={cx('commonFilepicker')}>
													<ImageUploadComponent
														className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
														subTextClass={cx(s.subText, 'textWhiteTwo')}
														subText={formatMessage(messages.maximumUploadSizeLabel)}
														defaultMessage={formatMessage(messages.chooseFile)}
														postUrl={api.apiEndpoint + '/uploadProfileImage'}
														handleDropzone={this.successProfile}
														loaderName={'userProfileLoading'}
														loader={userProfileLoading}
														fieldName={'picture'}
														formName={'EditPartnerForm'}
														imageSrc={picture ? api.apiEndpoint + profilePhotouploadDir + 'medium_' + picture : null}
														label={formatMessage(messages.profilePicture)}
														labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
													/>
												</div>
											</div>
										</Form.Group>
									</Col>

									<Col lg={6} md={12} sm={12} xs={12} className={cx(bt.space2, s.marbtm14)}>
										<Form.Group className={s.formGroup}>
											<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
												<label className={bt.labelText} >{formatMessage(messages.userIdentity)}</label><br />
												<Loader
													show={userIdentityLoading}
													type={"page"}
												>
													{
														identityDocument && identityDocument.length === 0 &&
														<div className={cx(s.backgroundImg, s.defaultIcon, 'darkModeDefaultImg')} style={{ backgroundImage: `url(${defaultIcon})` }} />
													}

													<div className='container-fluid'>
														<div className={cx('row')}>
															{
																identityDocument && identityDocument.length > 0 && identityDocument.map((item, key) => {
																	return (
																		<Col lg={4} md={4} sm={6} xs={12} className={s.editPartnerImgBottomSpce}>
																			<div className={s.bannerImageBg} style={{ backgroundImage: `url(${api.apiEndpoint + documentUploadDir}medium_${item.imageName})` }} />
																			<a href="javascript:void(0);" onClick={() => removeExperience(id, item.imageName, 'identityDocument')} className={cx(s.bannerDelete, 'trashIconNewRTL')}>
																				<img src={deleteIcon} alt='Delete' />
																			</a>
																		</Col>
																	);
																})
															}
														</div>
													</div>
												</Loader>
												<div className={'commonFilepicker'}>
													<ImageUploadComponent
														className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
														subTextClass={cx(s.subText, 'textWhiteTwo')}
														subText={formatMessage(messages.maximumUploadSizeLabel)}
														defaultMessage={formatMessage(messages.chooseFile)}
														postUrl={api.apiEndpoint + '/uploadIdentityImage'}
														handleDropzone={this.successIdentity}
														loaderName={'userIdentityLoading'}
														loader={userIdentityLoading}
														isLoaderExist={true}
													/>
												</div>
											</div>
										</Form.Group>
									</Col>

									<Col lg={6} md={12} sm={12} xs={12} className={cx(bt.space2, s.marbtm14)}>
										<Form.Group className={s.formGroup}>
											<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
												<label className={bt.labelText} >{formatMessage(messages.userExperience)}</label><br />
												<Loader show={userExperienceLoading} type={"page"}>

													{
														experienceDocument && experienceDocument.length === 0 &&
														<div className={cx(s.backgroundImg, s.defaultIcon, 'darkModeDefaultImg')} style={{ backgroundImage: `url(${defaultIcon})` }} />
													}

													<div className='container-fluid'>
														<div className={cx('row')}>
															{
																experienceDocument && experienceDocument.length > 0 && experienceDocument.map((item, key) => {
																	return (
																		<Col lg={4} md={4} sm={6} xs={12} className={s.editPartnerImgBottomSpce}>
																			<div className={s.bannerImageBg} style={{ backgroundImage: `url(${api.apiEndpoint + documentUploadDir}medium_${item.imageName})` }} />
																			<a href="javascript:void(0);" onClick={() => removeExperience(id, item.imageName, 'experienceDocument')} className={cx(s.bannerDelete, 'trashIconNewRTL')}>
																				<img src={deleteIcon} alt='Delete' />
																			</a>
																		</Col>
																	);
																})
															}
														</div>
													</div>
												</Loader>
												<div className={'commonFilepicker'}>
													<ImageUploadComponent
														className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
														subTextClass={cx(s.subText, 'textWhiteTwo')}
														subText={formatMessage(messages.maximumUploadSizeLabel)}
														defaultMessage={formatMessage(messages.chooseFile)}
														postUrl={api.apiEndpoint + '/uploadExperienceImage'}
														handleDropzone={this.successExperience}
														loaderName={"userExperienceLoading"}
														loader={userExperienceLoading}
														isLoaderExist={true}
													/>
												</div>
											</div>
										</Form.Group>
									</Col>

									<Col lg={6} md={12} sm={12} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="firstName"
													type="text"
													placeholder={formatMessage(messages.firstName)}
													component={this.renderField}
													label={formatMessage(messages.firstName)}
													labelClass={bt.labelText}
													fieldClass={bt.formControlInput}
												/>
											</div>
										</Form.Group>
									</Col>
									<Col lg={6} md={12} sm={12} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="lastName"
													type="text"
													placeholder={formatMessage(messages.lastName)}
													component={this.renderField}
													label={formatMessage(messages.lastName)}
													labelClass={bt.labelText}
													fieldClass={bt.formControlInput}
												/>
											</div>
										</Form.Group>
									</Col>
									<Col lg={6} md={12} sm={12} xs={12} className={cx(bt.space2)}>
										<div><label className={bt.labelText} >{formatMessage(messages.phoneNumber)}</label></div>
										<div className={s.countryGrid}>
											<div className={cx(s.displayInlineBlock, 'phoneColor')}>
												<Form.Group className={s.formGroup}>
													<div>
														<Field
															name="phoneDialCode"
															type="text"
															placeholder={formatMessage(messages.phoneDialCode)}
															component={this.renderFieldPhoneNumber}
															labelClass={bt.labelText}
															fieldClass={cx(bt.formControlInput, bt.formControlInputCountryCode)}
															writeOnce={true}
														/>
													</div>
												</Form.Group>
											</div>
											<div className={cx(s.displayInlineBlock, 'phoneNumber')}>
												<Form.Group className={s.formGroup}>
													<div>
														<Field
															name="phoneNumber"
															type="text"
															placeholder={formatMessage(messages.phoneNumber)}
															component={this.renderFieldPhoneNumber}
															labelClass={bt.labelText}
															fieldClass={cx(bt.formControlInput, bt.formControlInputCountry)}
															disabled={true}
														/>
													</div>
												</Form.Group>
											</div>
										</div>
									</Col>
									<Col lg={6} md={12} sm={12} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="email"
													type="text"
													component={this.renderField}
													placeholder={formatMessage(messages.email)}
													label={formatMessage(messages.email)}
													labelClass={bt.labelText}
													fieldClass={bt.formControlInput}
													disabled={true}
												/>
											</div>
										</Form.Group>
									</Col>
									<Col lg={6} md={12} sm={12} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="companyName"
													type="text"
													component={this.renderField}
													placeholder={formatMessage(messages.companyName)}
													label={formatMessage(messages.companyName)}
													labelClass={bt.labelText}
													fieldClass={bt.formControlInput}
												/>
											</div>
										</Form.Group>
									</Col>
									<Col lg={6} md={12} sm={12} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="workLicenceNumber"
													type="text"
													component={this.renderField}
													placeholder={formatMessage(messages.workLicenceNumber)}
													label={formatMessage(messages.workLicenceNumber)}
													labelClass={bt.labelText}
													fieldClass={bt.formControlInput}
												/>
											</div>
										</Form.Group>
									</Col>
									<Col lg={3} md={6} sm={6} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<label className={bt.labelText} >{formatMessage(messages.userStatus)}</label><br />
												<Field name="userStatus" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
													<option value="pending">{formatMessage(messages.pending)}</option>
													<option value="active">{formatMessage(messages.approve)}</option>
													<option value="inactive">{formatMessage(messages.decline)}</option>
												</Field>
											</div>
										</Form.Group>
									</Col>
									<Col lg={3} md={6} sm={6} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<label className={bt.labelText} >{formatMessage(messages.banStatus)}</label><br />
												<Field name="isBan" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
													<option value="0">{formatMessage(messages.permit)}</option>
													<option value="1">{formatMessage(messages.ban)}</option>
												</Field>
											</div>
										</Form.Group>
									</Col>
									<Col lg={3} md={6} sm={6} xs={12} className={bt.space2}>
										<Form.Group className={s.formGroup}>
											<div>
												<label className={bt.labelText}>{formatMessage(messages.preferredCurrency)}</label><br />
												<Field name='preferredCurrency' className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
													{currency && currency?.availableCurrencies.map(item => (
														<option key={item?.id} value={item?.symbol}>{item?.symbol}</option>
													))}
												</Field>
											</div>
										</Form.Group>
									</Col>
								</Row>
								<div className={cx(bt.textAlignRight, bt.spaceTop3, 'textAlignLeftRTL', 'loadingBtnRTL')}>
									<Form.Group className={s.formGroup}>
										<div className={s.displayInlineBlock}>
											<Loader
												type={"button"}
												label={formatMessage(messages.update)}
												show={loading}
												buttonType={'submit'}
												className={cx(s.button, bt.btnPrimary)}
												disabled={submitting || loading}
												isSuffix={true}
											/>
										</div>
										<Link to={"/siteadmin/partners"} className={cx(s.backBtn, bt.btnSecondary, 'backBtnRTL')}>{formatMessage(messages.goBack)}</Link>
									</Form.Group>
								</div>
							</Form>
						</Card>
					</Col>
				</Row>
			</div >
		)
	}
}
EditPartnerForm = reduxForm({
	form: 'EditPartnerForm', // a unique name for this form
	validate,
	onSubmit: submit
})(EditPartnerForm)
const selector = formValueSelector('EditPartnerForm')
const mapState = state => ({
	id: selector(state, 'id'),
	picture: selector(state, 'picture'),
	identityDocument: selector(state, 'identityDocument'),
	experienceDocument: selector(state, 'experienceDocument'),
	loading: state?.loader?.EditPartner,
	userProfileLoading: state?.loader?.userProfileLoading,
	userIdentityLoading: state?.loader?.userIdentityLoading,
	userExperienceLoading: state?.loader?.userExperienceLoading,
	currency: state?.currency
})
const mapDispatch = {
	removeExperience,
	uploadIdentity,
	uploadProfileImage,
	change,
	uploadExperience
}
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(EditPartnerForm)));
